export default __webpack_public_path__ + "static/media/logo-quicken.005b3567.svg";